export const GETIDP_REQUEST = 'GETIDP_REQUEST';
export const GETIDP_SUCCESS = 'GETIDP_SUCCESS';
export const GETIDP_FAILURE = 'GETIDP_FAILURE';

export const PUTIDP_REQUEST = 'GETIDP_REQUEST';
export const PUTIDP_SUCCESS = 'PUTIDP_SUCCESS';
export const PUTIDP_FAILURE = 'PUTIDP_FAILURE';
export const CLEAR_ERROR = 'CLEAR_ERROR';
